import { useStammdatenRepository } from '@Hooks/useRepository';
import { type ApiImportExternalErpContactsRequest } from '@Model';
import { ExternalErpAddressesRepository } from '@Repositories/Stammdaten';
import { ListRequest, unwrapOr } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import { withExternalIdsAsIds } from './withExternalIdsAsIds';

export function useImportContactsForExternalAddress(externalAddressId: string) {
    const externalAddresses = useStammdatenRepository(ExternalErpAddressesRepository);

    const { mutateAsync: loadImportableContacts } = useMutation({
        mutationFn: (lr: ListRequest) =>
            externalAddresses.getImportableContacts(externalAddressId, lr.page_no, lr.page_size),
    });

    const { mutateAsync: importAsync, isPending: isImporting } = useMutation({
        mutationFn: (request: ApiImportExternalErpContactsRequest) =>
            externalAddresses.importContacts(externalAddressId, request),
    });

    const loadContacts = useCallback(
        async (lr: ListRequest) => {
            const result = await loadImportableContacts(lr);

            return withExternalIdsAsIds(
                unwrapOr(result, {
                    page_count: 0,
                    page_size: 0,
                    page_no: 0,
                    total_item_count: 0,
                    items: [],
                }),
            );
        },
        [loadImportableContacts],
    );

    return {
        loadContacts,
        isImporting,
        importAsync,
    };
}
